import React, { useMemo } from "react";

import moment from "moment";
import PropTypes from "prop-types";

import DedicatedContainer from "src/organization/pages/project/environment/metrics/containers/Dedicated";
import Split from "src/organization/pages/project/environment/metrics/containers/Split";
import useDimensions from "src/organization/pages/project/environment/metrics/hooks/useDimensions";
import { timeframes } from "src/organization/pages/project/environment/metrics/resources/settings";
import isSplitArchitecture from "src/organization/pages/project/environment/metrics/utils/isSplitArchitecture";

const Dedicated = ({ link }) => {
  const now = moment();
  const query = useMemo(
    () => ({
      stream: {
        collection: link?.collection,
        stream: "metrics"
      },
      range: {
        to: now.format(),
        from: now.subtract(timeframes[0]?.range, "seconds").format()
      }
    }),
    [link?.collection, now]
  );

  const { dimension, isLoadingDimensions } = useDimensions(link?.href, query);

  const isSplit = isSplitArchitecture(dimension);

  if (isLoadingDimensions) {
    return null;
  }

  return isSplit ? <Split link={link} /> : <DedicatedContainer link={link} />;
};

Dedicated.propTypes = {
  link: PropTypes.shape({
    collection: PropTypes.string,
    href: PropTypes.string
  })
};

export default Dedicated;
